import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import { List, ListItem, ListItemText } from "@material-ui/core";
import "./App.css";
import "./panels/base_panel.css";

import BuildIcon from "@material-ui/icons/Build";
import DnsOutlinedIcon from "@material-ui/icons/DnsOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import EmojiEventsOutlinedIcon from "@material-ui/icons/EmojiEventsOutlined";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import SearchIcon from "@material-ui/icons/Search";
import HistoryIcon from "@material-ui/icons/History";

import AnnouncementsPanel from "./panels/announcements_panel";
import CharacterInfoPanel from "./panels/character_info_panel";
import ErrorCodePanel from "./panels/error_code_panel";
import LeaderboardPanel from "./panels/closed_beta_leaderboard_panel";
import PlayerInfoPanel from "./panels/player_info_panel";
import SearchPanel from "./panels/search_panel";
import ServerPanel from "./panels/server_panel";
import AdminHistoryPanel from "./panels/admin_history_panel";
import DeveloperToolsPanel from "./panels/developer_tools_panel";

function App() {
  return (
    <div className="App">
      <Router>
        <div className="wrapper">
          <div
            className={
              window.location.hostname.includes("-prod")
                ? "main-header production"
                : "main-header"
            }
          >
            BattleRun Admin Page
          </div>

          <div className="main-nav">
            <List>
              <ListItem button component={Link} to={"/search"}>
                <SearchIcon className="nav-icon" />
                <ListItemText primary="Search" />
              </ListItem>
              <ListItem button component={Link} to={"/announcements"}>
                <EmailOutlinedIcon className="nav-icon" />
                <ListItemText primary="Announcements" />
              </ListItem>
              <ListItem button component={Link} to={"/leaderboard"}>
                <EmojiEventsOutlinedIcon className="nav-icon" />
                <ListItemText primary="Leaderboard" />
              </ListItem>
              <ListItem button component={Link} to={"/server"}>
                <DnsOutlinedIcon className="nav-icon" />
                <ListItemText primary="Server" />
              </ListItem>
              <ListItem button component={Link} to={"/admin-history"}>
                <HistoryIcon className="nav-icon" />
                <ListItemText primary="Admin History" />
              </ListItem>
              <ListItem button component={Link} to={"/error-codes"}>
                <ErrorOutlineIcon className="nav-icon" />
                <ListItemText primary="Error Codes" />
              </ListItem>
              <ListItem button component={Link} to={"/developer-tools"}>
                <BuildIcon className="nav-icon" />
                <ListItemText primary="Developer Tools" />
              </ListItem>
            </List>
          </div>

          <div className="main-content">
            <Switch>
              <Route exact path="/" component={SearchPanel} />
              <Route path="/search" component={SearchPanel} />
              <Route path="/player/:playerID?" component={PlayerInfoPanel} />
              <Route
                path="/character/:characterID?"
                component={CharacterInfoPanel}
              />
              <Route
                path="/announcements"
                exact
                component={AnnouncementsPanel}
              />
              <Route path="/leaderboard" exact component={LeaderboardPanel} />
              <Route path="/server" exact component={ServerPanel} />
              <Route
                path="/admin-history"
                exact
                component={AdminHistoryPanel}
              />
              <Route path="/error-codes" exact component={ErrorCodePanel} />
              <Route
                path="/developer-tools"
                exact
                component={DeveloperToolsPanel}
              />
            </Switch>
          </div>
        </div>
      </Router>
    </div>
  );
}

export default App;
